import React, { useEffect, useState } from 'react';
import useApiGet from '../../../DataServices/useApiGet';
import LoadingIndicator from '../../../Layout/LoadingIndicator';
import { ErrorComponent } from '../../../Layout/ErrorComponent';
import Location from './Location';
import MembershipOffer from './MembershipOffer';

import TagManager from 'react-gtm-module';
// Seeting up GTM props for Add Retail page.
const tagManagerArgs = {
    dataLayer: {
        page: 'add-retail',
        event:'spa-pageview'
    }
}

// Main container for Add retail location page. 
const AddRetail = (props) => {
  const [retails, setRetails] = useState([]);
  const [postalCode, setPostalCode] = useState(props.customer.postalCode);
  const [activeAdd, setActiveAdd] = useState(false);
  const [newRetail, setNewRetail] = useState();
  const [offer, setOffer] = useState(false);
  let displayRetails = '';
  let showSearch = 'show';
  let existingLocations = [];
  props.existingLocations.forEach(o => existingLocations.push(parseInt(o.retailID)));

  useEffect(() =>{
    TagManager.dataLayer(tagManagerArgs)
  }, [])

  // Retrive locations closest to the postal code.
  var { data, error, isLoaded, triggerFetch } = useApiGet(
    "/retailLocationsForCdp/"
    +postalCode.replace(/ /g,'')
  );

  // Compare returned locations with the list of locations customer already has.
  // Assign "duplicate" attribute to the existine locations. 
  useEffect(() => {
    if(isLoaded) {
      var locs = [...data];
      locs = locs.map(p =>
        existingLocations.includes(p.retailId)
          ? { ...p, duplicate: "duplicate" }
          : { ...p, duplicate: "unique" }
      )
      setRetails(locs);
    }
  }, [data, isLoaded]);

  // Postal code field changes.
  const handlePostalCode = (e) => {
    setPostalCode(e.target.value)
  }
  
  // triggers new search for the new postal code.
  const handleSearch = e => {
    e.preventDefault();
    triggerFetch();
    setActiveAdd(false);
  }

  const handleRemove = () => {
    setActiveAdd(false)
  }

  // Handles membership number field.
  const addMembershipNumber = (id, mn) => {
    let loc = {...newRetail}
    setNewRetail({...loc, membershipNumber:mn})
  }

  // Hendles Primary location assignment.
  const makePrimary = () => {
    let loc = {...newRetail}
    setNewRetail({...loc, isPrimary:!loc.isPrimary})
  }

  // Sets the new location parameters and send it to the handler to prepare for save.
  const handleAddNewLocation = (location) => {
    const newRetail = {
      "isPrimary": false,
      "membershipNumber": '',
      "retailCity": location.retailCity,
      "retailID": location.retailId.toString(),
      "retailName": location.retailName,
      "retailProvince": location.retailProvince,
      "omf": location.omf,
      "website": location.website ? location.website: '',
      "shortname": location.shortname ? location.shortname:'',
    }
    setNewRetail(newRetail)
    setActiveAdd(true)    
  }

  // Prepares object to be stored in CDS and sends it to the Retail locations save handler.
  const saveNewRetail = () => {
    var loc = [{
      "retailId" : newRetail.retailID, 
      "isPrimary":newRetail.isPrimary, 
      "method": "add", 
      "membershipNumber":newRetail.membershipNumber
    }];
    props.addRetail(loc)
    props.setAddAnother(false)
  }

  // Checks if the new retail offers online membership in case where user didn't fill in the membership number.
  const handleSaveNewRetail = () => {
    if (!newRetail.membershipNumber) {
      if (newRetail.omf) {
        const url = "https://"+newRetail.website+"/sites/"+newRetail.shortname+"/membership/form"
        setNewRetail({...newRetail, url:url})
        setOffer(true)
      } else {
        saveNewRetail();
      }
    } else {
      saveNewRetail();
    }
  }
  // Handles key press functionality.
  const handleKeyPressFactory = (location) => ((event) => {
    if (event.key === 'Enter'){
      handleAddNewLocation(location)
    }
  })

  // Dsiplays membership upsell.
  if (offer) {
    return <MembershipOffer 
      url={newRetail.url}
      setOffer={setOffer}
      saveNewRetail={saveNewRetail}/>;
  }

  if (!isLoaded && !error) {
    return <LoadingIndicator />;
  }

  if (error) {
    <ErrorComponent />
  }

  if (retails.length > 0 && !activeAdd) {
    displayRetails = retails.map((location) =>
      <div 
        className={location.duplicate + " retail"} 
        key={location.retailId+Math.random()} 
        onClick={() => (location.duplicate === "duplicate") ? false : handleAddNewLocation(location)}
        onKeyPress={(location.duplicate === "duplicate") ? undefined : handleKeyPressFactory(location)}
        role={(location.duplicate === "duplicate") ? '' : "button"}
        tabIndex={(location.duplicate === "duplicate") ? '' : "0"}
      >
        <div className="coop-name">{location.retailName}</div>
        <div>{location.retailProvince}</div>
      </div>
    );
  } else if (activeAdd) {
    displayRetails = <>
          <Location 
            action='add'
            key={newRetail.retailID} 
            location={newRetail}
            remove={handleRemove}
            changePrimary={makePrimary}
            selectLocation={undefined}
            editable={newRetail.retailID}
            changeMembershipNumber={addMembershipNumber}
          />
          <div className="buttons">
            <button 
              type="button" 
              className="save btn primary" 
              onClick={()=>handleSaveNewRetail()} 
              aria-label="Save"
            >Save</button>
          </div>
        </>
  }

  return (
    <div className="add-retail">
      <form onSubmit={handleSearch}>
      <p className="label-message">Enter postal code to find nearest Co-op</p>
      <div className={"form-group fg--search "+showSearch}>
        <input 
          type="text" 
          className="input" 
          placeholder="Search Retail by Postal Code" 
          value={postalCode || ''} 
          onChange={handlePostalCode} 
          pattern="^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$" 
          required aria-required="true"
        />
        <button 
          type="submit" 
          aria-label="Search" 
        ><i className="fa fa-search"></i></button>
      </div>
      { (error !== null) ? <div className='error'>There seem to be an issue with the postal code you entered. Please try again.</div>:''}
      </form>
      {displayRetails}
      <div className="buttons">
        <button 
          type="button" 
          className="cancel btn secondary" 
          onClick={()=>props.setAddAnother(false)} 
          aria-label="Cancel"
        >Cancel</button>
      </div>
    </div>
  );
}

export default AddRetail;